import { makeAutoObservable } from "mobx"
import Store from ".."
import LoyaltyStoreX from "../loyalty"
import {getAll, getBranchesStaffs} from "../../api/branches"

export default class BranchesApiStore {

  mainStore: Store
  loyaltyStore: LoyaltyStoreX

  branches: any[] = []
  staffs: any[] = []

  searchBranch: string = ""
  branchesSearched: any[] = []

  selectedBranch: any | null = null

  constructor(main: Store, loyalty: LoyaltyStoreX) {
    makeAutoObservable(this)

    this.mainStore = main
    this.loyaltyStore = loyalty
  }

  public setSelectedBranch = (val: any) => this.selectedBranch = val
  public setSearchBranch = (val: string) => this.searchBranch = val
  public setStaffs = (val: any[]) => this.staffs = val
  public setBranches = (val: any[]) => this.branches = val
  public setBranchesSearched = (val: any[]) => this.branchesSearched = val
    
  public async fetchStaffs(id: number) {
    const res = await getBranchesStaffs(id)
    this.setStaffs(res.staff)
  }

  public async fetchBranches() {
    const res = await getAll("topgun")
    let branches: any[] = [...res.branches]
  
    branches = branches.sort((a: any, b: any) => {
      if (a.id > b.id) {
        return 1
      } else if (a.id < b.id) {
        return -1
      } else {
        return 0
      }
    })
  
    let brnchs: any[] = []
  
    branches.forEach(country => {
      country.regions.forEach(region => {
        region.items.forEach(item => {
          brnchs.push(item)
        })
      })
    })
  
    this.setBranchesSearched(brnchs.slice(0, 20))
    this.setBranches(brnchs)
  }
  

}